import { style, styleVariants } from "@vanilla-extract/css";
import { breakpoints, textTruncate, vars } from "plos/src/styles";

const baseInfoItemStyles = style({
  display: "flex",
  flexDirection: "column",
  border: vars.borders.outlineVariant,
  borderRadius: vars.radii.l,
  padding: vars.space.m,
});

export const infoItem = styleVariants({
  default: [
    baseInfoItemStyles,
    {
      gap: vars.space.xs,
    },
  ],
  photo: [
    baseInfoItemStyles,
    {
      gap: vars.space.m,
      "@media": {
        [`screen and (max-width: ${breakpoints[4]})`]: {
          flexDirection: "row",
          gridColumn: "span 2",
        },
      },
    },
  ],
});

export const infoItemPhotoHeadingContainer = style({
  "@media": {
    [`screen and (max-width: ${breakpoints[4]})`]: {
      display: "flex",
      flexDirection: "column",
      gap: vars.space["2xs"],
    },
  },
});

export const infoItemHeading = style([
  textTruncate,
  {
    color: vars.colors.onSurfaceVariant,
    fontFamily: vars.fonts.regular,
    fontSize: vars.fontSizes.body.m,
  },
]);

export const infoItemValue = style([
  textTruncate,
  {
    color: vars.colors.onSurface,
    fontFamily: vars.fonts.bold,
    fontSize: vars.fontSizes.heading.l,
  },
]);
